import React, { useState } from 'react';
import { ProductProvider } from './context/ProductContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import Store from './components/store/Store';
import Admin from './components/admin/Admin';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';

function AppContent() {
  const [view, setView] = useState('store');
  const [authView, setAuthView] = useState('login');
  const [showAuth, setShowAuth] = useState(false);
  const { currentUser, isAdmin, signout } = useAuth();

  // If trying to access admin without being logged in as admin
  if (view === 'admin') {
    if (!currentUser || !isAdmin) {
      // Show login for admin access
      if (authView === 'login') {
        return (
          <Login
            onSwitchToSignup={() => setAuthView('signup')}
            onLoginSuccess={() => setView('admin')}
            onCancel={() => setView('store')}
            isAdminLogin={true}
          />
        );
      }
    }
    
    // User is admin, show admin panel
    return (
      <Admin 
        onSwitchToStore={() => setView('store')}
        onSignout={() => {
          signout();
          setView('store');
        }}
      />
    );
  }

  // Show auth screens if user explicitly wants to sign in/up
  if (showAuth) {
    if (authView === 'login') {
      return (
        <Login
          onSwitchToSignup={() => setAuthView('signup')}
          onLoginSuccess={() => {
            setShowAuth(false);
            setView('store');
          }}
          onCancel={() => setShowAuth(false)}
          isAdminLogin={false}
        />
      );
    } else {
      return (
        <Signup
          onSwitchToLogin={() => setAuthView('login')}
          onSignupSuccess={() => {
            setShowAuth(false);
            setView('store');
          }}
          onCancel={() => setShowAuth(false)}
        />
      );
    }
  }

  // Show store (available to everyone)
  return (
    <Store 
      onSwitchToAdmin={() => setView('admin')}
      onShowAuth={() => setShowAuth(true)}
      onSignout={() => {
        signout();
        setView('store');
      }}
    />
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ProductProvider>
        <AppContent />
      </ProductProvider>
    </AuthProvider>
  );
}